module.exports = __webpack_public_path__ + "r-v3/img/play_white.f91620f8.svg";